module.exports = __webpack_public_path__ + "static/media/statistics.7829ee0e.png";